<template>
    <v-dialog v-model="show" scrollable max-width="800px">
        <v-card>
            <v-card-title>
                <slot name="header">
                </slot>
                <slot>
                    <v-spacer></v-spacer>
                    <v-btn small icon @click.native="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </slot>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <slot name="body">
                </slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
  props: ['visible'],
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  }
}
</script>
